import { ChevronDown, ChevronRight } from 'react-feather';
import { formatPhoneNumber } from '../../hooks/phoneFormat';

const OrderClientInfoSection = ({
	sections,
	toggleSection,
	orderDetails,
}) => {
	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div
					className="title-block"
					onClick={() => toggleSection('client')}
				>
					<h2 className="title-h2">Client Information</h2>
					<button>
						{sections.client ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.client && (
					<>
						<div className="grid grid-flow-row-dense grid-cols-2 grid-rows-2 content-block">
							<p className="data-content">
								<strong>First Name</strong>
								{orderDetails.client.firstName}
							</p>
							<p className="data-content">
								<strong>Last Name</strong>
								<div>{orderDetails.client.lastName}</div>
							</p>
							<p className="data-content">
								<strong>Phone</strong>
								<a href={`tel:+1${orderDetails.client.phoneNumber}`}>
									{formatPhoneNumber(orderDetails.client.phoneNumber)}
								</a>
							</p>
							<p className="data-content">
								<strong>Email</strong>
								<a href={`mailto:${orderDetails.client.email}`}>
									{orderDetails.client.email}
								</a>
							</p>
						</div>
						<div className="w-full block-subtitle">
							<h3 className="title-h2">Delivery Address</h3>
						</div>
						<div className="content-box grid grid-cols-2 content-block">
							<p className="data-content">
								<strong>Street</strong>
								<div>{orderDetails.address}</div>
							</p>
							<p className="data-content">
								<strong>City</strong>
								<div>{orderDetails.city}</div>
							</p>
							<p className="data-content">
								<strong>State</strong>
								<div>{orderDetails.state}</div>
							</p>
							<p className="data-content">
								<strong>Zipcode</strong>
								<div>{orderDetails.postalCode}</div>
							</p>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default OrderClientInfoSection;
